import React from "react";
import { useTheme, css } from "@emotion/react";

import ContentSection from "core/Components/ContentSection";

type Props = {
    children: React.ReactNode,
    className?: string,
};

const PageHeaderAndDropdownsContainer: React.FC<Props> = ({ children, className = "" }) => {
    const theme = useTheme();

    const style = css`
        ${theme.breakpoints.down("md")} {
            flex-direction: column;
        }
    `;

    return (
        <ContentSection justifyContent={"space-between"} height={"unset"} css={style} className={className}>
            {children}
        </ContentSection>
    );
};

export default PageHeaderAndDropdownsContainer;
